import { get, isEmpty, isNil } from 'lodash';
import { NEW_EXISTING_RADIO_STATE_KEY } from '@zocdoc/components/src/newexistingradio/NewExistingRadioSelector';
import { PROCEDURE_DROPDOWN_STATE_KEY } from '@zocdoc/components/src/ProcedureDropdown/ProcedureDropdownSelector';
import { INSURANCE_PICKER_KEY } from '@zocdoc/components/src/InsurancePicker';
import { getProfilePageParameters } from '../../state/selectors';

export const mapStateToProps = state => {
    const newPatientState = state[NEW_EXISTING_RADIO_STATE_KEY];
    const procedureDropdownState = state[PROCEDURE_DROPDOWN_STATE_KEY];
    const insurancePickerState = state[INSURANCE_PICKER_KEY];
    const { referrerType, widget } = getProfilePageParameters(state);

    const props = {
        referrerType,
        widget,
    };

    if (get(procedureDropdownState, 'procedureId')) {
        props.procedureId = procedureDropdownState.procedureId;
    }
    if (!isEmpty(newPatientState) && !isNil(newPatientState.isNewPatient)) {
        props.isExistingPatient = !(newPatientState.isNewPatient);
    }

    if (get(insurancePickerState, 'carrier') && get(insurancePickerState, 'plan')) {
        props.insuranceCarrierId = insurancePickerState.carrier;
        props.insurancePlanId = insurancePickerState.plan;
    }

    return props;
};
